import React, { useEffect } from 'react';
import DocumentPage from '../../components/documentPage/documentPage';
import { styles } from './styles';

// Shown for any path the app does not recognize — see index.tsx.
//
// This is a SOFT 404: firebase.json rewrites `**` to /index.html, so Hosting answers 200 and
// React decides what to render. Hosting's own 404.html can never fire while that rewrite
// exists, and the rewrite has to stay — it is what lets /legal resolve per-hostname, which
// Hosting cannot express. The `noindex` below is the mitigation: crawlers are told not to
// index this page even though the status line says 200.
const NotFound: React.FC = () => {

  useEffect(() => {

    const meta = window.document.createElement('meta');

    meta.name = 'robots';
    meta.content = 'noindex';
    window.document.head.appendChild(meta);

    // The marketing page sets `index, follow` in index.html and is rendered by the same
    // document, so this tag must come back out if the visitor navigates away client-side.
    return () => { meta.remove(); };
  }, []);

  return (
    <DocumentPage showClose={false} showBackLink={false}>
      <p style={styles.code}>Error 404</p>
      <h1 style={styles.pageTitle}>Page not found</h1>
      <p style={styles.paragraph}>
        The page you're looking for doesn't exist, or it has moved. If you followed a link to
        get here, it's out of date.
      </p>
      <a href="/" style={styles.home}>Go to novaeon.io</a>
    </DocumentPage>
  );
};

export default NotFound;
